<template>
<div>
    <div>
      <div class="tags has-addons" v-if="type === 'results'">
        <span class="tag is-medium is-success">{{ loading.active ? "Loading..." : "Results" }}</span>
        <span class="tag is-medium is-light">
          <span v-if="!loading.active">{{ count }}</span>
          <span v-else class="fas fa-spinner fa-spin"></span>
        </span>
      </div>

      <div class="tags has-addons" v-else-if="type === 'address'">
        <span class="tag is-medium is-primary">Distance from {{ address }}</span>
        <span
          class="tag is-medium is-delete hover-cursor-pointer"
          role="button" tabindex="0" aria-label="remove filter"
          @click="removeAddress" @keyup.enter="removeAddress">
        </span>
      </div>

      <div class="tags has-addons" v-else-if="type === 'gradeLevel'">
        <span class="tag is-medium is-warning" v-text="title"></span>
        <span
          class="tag is-medium is-delete hover-cursor-pointer"
          role="button" tabindex="0" aria-label="remove filter"
          @click="removeGradeLevel" @keyup.enter="removeGradeLevel">
        </span>
      </div>

      <div class="tags has-addons" v-else-if="type === 'feature'">
        <span class="tag is-medium is-info" v-text="title"></span>
        <span
          class="tag is-medium is-delete hover-cursor-pointer"
          role="button" tabindex="0" aria-label="remove filter"
          @click="removeFeature" @keyup.enter="removeFeature">
        </span>
      </div>
    </div>
  </div>

</template>

<script>
	export default {
		props: ['title', 'type', 'count', 'address'],
		computed: {
      loading() { return this.$store.state.main.loading },
			schools() { return this.$store.state.main.schools },
			filteredSchools() { return this.$store.state.main.filteredSchools }
		},
		methods: {
			removeGradeLevel() {
				this.$store.commit('updateGradeLevel', '')
				this.$store.dispatch('basicSearch')
				this.returnFocusToResults()
			},
			removeFeature() {
				this.$store.commit('toggleFeature', { name: this.title, checked: false })
				this.$store.dispatch('basicSearch')
				this.returnFocusToResults()
			},
			removeAddress() {
				this.$store.commit('updateGeocodedResults', {active: false, latLng: {}, address: ''})
	      this.$store.dispatch('basicSearch')
	      this.returnFocusToResults()
			},
			returnFocusToResults() {
				document.querySelector('#card-search-results').focus()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tags.has-addons {
		overflow: auto;
	}
</style>
